import { CommonEnums } from '../../common.enums';

export class Office365_Inst {
    office365_Inst_Id: number;
    nm: string;
    description: string;
    ver: string;
    valid_Cd: string;
    dxFlow_Id: number;
    updateBy: string;
    lastUpdateBy: string;
    updateDt: Date;
    disableFlg: string;
    src_ConnNm: string;
    tgt_ConnNm: string;
    retryEnabled: string;
    numOfRetryAttempts: number;
    retryWaitTime: number;

    constructor() {
        this.setDefault();
    }

    setDefault(): void {
        this.office365_Inst_Id = CommonEnums.defaults.LONG_VAL;
        this.nm = CommonEnums.defaults.STRING_EMPTY;
        this.description = CommonEnums.defaults.STRING_EMPTY;
        this.ver = CommonEnums.defaults.STRING_EMPTY;
        this.valid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.dxFlow_Id = CommonEnums.defaults.LONG_VAL;
        this.updateBy = CommonEnums.defaults.STRING_EMPTY;
        this.lastUpdateBy = CommonEnums.defaults.STRING_EMPTY;
        this.updateDt = new Date();
        this.disableFlg = CommonEnums.defaults.STRING_VAL_NO;
        this.src_ConnNm = CommonEnums.defaults.STRING_EMPTY;
        this.tgt_ConnNm = CommonEnums.defaults.STRING_EMPTY;
        this.retryEnabled = CommonEnums.defaults.STRING_VAL_NO;
        this.numOfRetryAttempts = 2;
        this.retryWaitTime = 60;
    }

    get PrimaryKey(): string {
        return this.office365_Inst_Id + '.' + this.dxFlow_Id;
    }

    copy(): Office365_Inst {
        let office365Tmp: Office365_Inst = new Office365_Inst();

        office365Tmp.office365_Inst_Id = this.office365_Inst_Id;
        office365Tmp.nm = this.nm;
        office365Tmp.description = this.description;
        office365Tmp.ver = this.ver;
        office365Tmp.valid_Cd = this.valid_Cd;
        office365Tmp.dxFlow_Id = this.dxFlow_Id;
        office365Tmp.updateBy = this.updateBy;
        office365Tmp.lastUpdateBy = this.lastUpdateBy;
        office365Tmp.updateDt = this.updateDt;
        office365Tmp.disableFlg = this.disableFlg;
        office365Tmp.src_ConnNm = this.src_ConnNm;
        office365Tmp.tgt_ConnNm = this.tgt_ConnNm;
        office365Tmp.retryEnabled = this.retryEnabled;
        office365Tmp.numOfRetryAttempts = this.numOfRetryAttempts;
        office365Tmp.retryWaitTime = this.retryWaitTime;

        return office365Tmp;
    }

    copyFrom(office365Tmp: Office365_Inst): void {
        this.office365_Inst_Id = office365Tmp.office365_Inst_Id;
        this.nm = office365Tmp.nm;
        this.description = office365Tmp.description;
        this.ver = office365Tmp.ver;
        this.valid_Cd = office365Tmp.valid_Cd;
        this.dxFlow_Id = office365Tmp.dxFlow_Id;
        this.updateBy = office365Tmp.updateBy;
        this.lastUpdateBy = office365Tmp.lastUpdateBy;
        this.updateDt = office365Tmp.updateDt;
        this.disableFlg = office365Tmp.disableFlg;
        this.src_ConnNm = office365Tmp.src_ConnNm;
        this.tgt_ConnNm = office365Tmp.tgt_ConnNm;
        this.retryEnabled = office365Tmp.retryEnabled;
        this.numOfRetryAttempts = office365Tmp.numOfRetryAttempts;
        this.retryWaitTime = office365Tmp.retryWaitTime;
    }

    compare(office365Tmp: Office365_Inst): string {
        let office365String: string = this.toString(false);
        let office365TmpString: string = office365Tmp.toString(false);

        if (office365String != office365TmpString) {
            return office365String + ', ' + office365TmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "Office365_Inst [office365_Inst_Id=" + this.office365_Inst_Id +
            ", nm=" + this.nm + ", description=" + this.description +
            ", ver=" + this.ver + ", updateBy=" + this.updateBy +", updateDt=" + this.updateDt +
            ", valid_Cd=" + this.valid_Cd + ", dxFlow_Id=" + this.dxFlow_Id + ", disableFlg=" + this.disableFlg +
            ",retryEnabled =" + this.retryEnabled +
            ",numOfRetryAttempts="+ this.numOfRetryAttempts +
           ", retryWaitTime= "+ this.retryWaitTime;
        if (isNotCompare) {
            str += ", lastUpdateBy=" + this.lastUpdateBy+
            ", src_ConnNm=" + this.src_ConnNm +
            ", tgt_ConnNm=" + this.tgt_ConnNm;

        }  
        str += ']';
        return str;
    }
}
